import {useMemo} from 'react';

import {usePanelSearchDebouncedContext} from '../../../state/panelbank/PanelSearchContextProvider';
import {getIsSectionNameSearchMatch} from '../sectionLayout/useSectionNameMatch';
import {getSectionFilteredPanels} from '../sectionLayout/useSectionPanels';
import {useWorkspaceSections} from '../sections/useWorkspaceSections';

export const useSearchResultCounts = () => {
  const visibleSections = useWorkspaceSections();
  const {debouncedSearchRegex: searchRegex} = usePanelSearchDebouncedContext();

  return useMemo(() => {
    let numPanelsMatched = 0;
    let numSectionsMatched = 0;

    for (const section of visibleSections) {
      const isSectionNameSearchMatch = getIsSectionNameSearchMatch(
        section.name,
        searchRegex
      );
      const panelSearchmatchCount = getSectionFilteredPanels({
        activePanels: section.panels,
        searchRegex,
        isSectionNameSearchMatch,
      });

      numPanelsMatched += panelSearchmatchCount.length;
      numSectionsMatched += isSectionNameSearchMatch ? 1 : 0;
    }

    return {
      numPanelsMatched: numPanelsMatched,
      numSectionsMatched: numSectionsMatched,
    };
  }, [visibleSections, searchRegex]);
};
